export default __webpack_public_path__ + "static/media/closeBox.9ae49e95.svg";